import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import PhoneIcon from '@mui/icons-material/Phone'
import usePageProps from 'hooks/usePageProps'
import WhatsappIcon from 'components/icons/whatsapp.svg'
import Link from '@mui/material/Link'
import sx from './styles'

function Section1() {
  const {
    shoppingPhone: companyPhone, whatsapp, whatsappWelcomeMessage, contactPhoneDisplay,
  } = usePageProps()

  return (
    <Container sx={sx.root}>
      <Typography
        component="h1"
        variant="h3"
        align="center"
        sx={sx.title}
      >
        <FormattedMessage id="CONTACT_TITLE" />
      </Typography>

      <Typography
        align="center"
        sx={sx.subtitle}
        variant="body1"
      >
        <FormattedMessage id="CONTACT_SUBTITLE" />
      </Typography>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          size={{
            xs: 6,
            md: 3,
            lg: 2,
          }}
          component={Link}
          href={`tel:${companyPhone}`}
          target="_blank"
          sx={sx.link}
        >
          <PhoneIcon
            fontSize="large"
            sx={sx.icon}
          />
          {contactPhoneDisplay}
        </Grid>

        <Grid
          size={{
            xs: 6,
            md: 3,
            lg: 2,
          }}
          component={Link}
          href={`//wa.me/${whatsapp}?text=${whatsappWelcomeMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={sx.link}
        >
          <WhatsappIcon sx={sx.icon} />
          {whatsapp}
        </Grid>
      </Grid>
    </Container>
  )
}

export default memo(Section1)
